import { useMemo } from "react";
import { useLocation } from "react-router";
import { getShipperOnboardingSectionId, type ShipperOnboardingSectionId } from "@/config/shipper-onboarding-sections";

/**
 * Macro-area Shipper corrente per onboarding, in base a `location.pathname`.
 */
export function useShipperOnboardingSection(): ShipperOnboardingSectionId | null {
    const { pathname } = useLocation();
    return useMemo(() => getShipperOnboardingSectionId(pathname), [pathname]);
}
